import React, { useState } from 'react';
import InfoTip from './InfoTip';

const KpiCard = ({ title, description, value, sub, color, bg, icon: Icon, onClick, targetId, active, alert }) => {
  const [hovered, setHovered] = useState(false);
  const c = color || '#6d4e36';
  const isClickable = !!(onClick || targetId);

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (targetId) {
      const el = document.getElementById(targetId);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div
      onClick={isClickable ? handleClick : undefined}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        borderRadius: 14,
        border: active
          ? `2px solid ${c}`
          : `1.5px solid ${c}28`,
        borderTop: `4px solid ${c}`,
        background: hovered ? `${c}12` : (bg || '#fff'),
        padding: '1rem 1.1rem 0.9rem',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        cursor: isClickable ? 'pointer' : 'default',
        transition: 'transform 0.17s ease, box-shadow 0.17s ease, background 0.17s ease',
        transform: hovered && isClickable ? 'translateY(-4px)' : 'none',
        boxShadow: hovered && isClickable
          ? `0 10px 28px ${c}35`
          : active
          ? `0 4px 14px ${c}25`
          : '0 2px 8px rgba(0,0,0,0.06)',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      {/* Decorative background icon */}
      {Icon && (
        <Icon style={{
          position: 'absolute', bottom: 6, right: 8,
          fontSize: '3rem', color: c, opacity: 0.07,
          pointerEvents: 'none'
        }} />
      )}

      {/* Title */}
      <div style={{
        fontSize: '0.7rem',
        color: '#999',
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        fontWeight: 700,
        marginBottom: 6,
        display: 'flex',
        alignItems: 'center',
      }}>
        {title}<InfoTip text={description} />
      </div>

      {/* Value */}
      <div style={{
        fontSize: '1.55rem',
        fontWeight: 800,
        color: c,
        lineHeight: 1.1,
        wordBreak: 'break-word'
      }}>
        {alert && <span style={{ marginRight: 4, fontSize: '1.1rem' }}>⚠️</span>}
        {value}
      </div>

      {/* Subtitle */}
      {sub && (
        <div style={{ fontSize: '0.75rem', color: '#888', marginTop: 5 }}>
          {sub}
        </div>
      )}

      {/* Scroll hint (dashboard only) */}
      {targetId && (
        <div style={{
          marginTop: 'auto',
          paddingTop: 10,
          color: c,
          fontSize: '0.7rem',
          fontWeight: 600,
          opacity: hovered ? 0.9 : 0.4,
          transition: 'opacity 0.17s'
        }}>
          ↓ voir détail
        </div>
      )}
    </div>
  );
};

export default KpiCard;
